// Multi-anchor cross-check — PSD §2.7 (F2.7). Engine layer (framework-free).
import { backsolve } from './backsolve';
/**
 * Cross-check multiple preferred-class anchors to detect inconsistencies.
 * Each anchor implies a different total equity value; deviations > 10% are flagged.
 */
export function crossCheckAnchors(inputs, breakpoints) {
    const cap = inputs.capTableSnapshot;
    const preferredInsts = cap.instruments.filter((i) => i.kind === 'preferred' && i.issuePrice > 0);
    if (preferredInsts.length < 2)
        return [];
    // Use the first anchor's implied V as the baseline
    const points = [];
    let baselineV = null;
    for (const inst of preferredInsts) {
        const variantInputs = {
            ...inputs,
            equityValue: {
                ...inputs.equityValue,
                anchorInstrumentId: inst.id,
                anchorPricePerShare: inst.issuePrice,
            },
        };
        try {
            const back = backsolve(variantInputs, breakpoints);
            if (baselineV === null)
                baselineV = back.V;
            const deltaPct = baselineV > 0 ? (back.V - baselineV) / baselineV : /* v8 ignore next */ 0;
            points.push({
                instrumentId: inst.id,
                impliedEquityValue: back.V,
                deltaPct,
            });
        }
        catch {
            // skip invalid anchors
        }
    }
    return points;
}
//# sourceMappingURL=multiAnchor.js.map